import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import ApprovedPurchaseOrderLayer from "../../../components/Admin/ApprovedPurchaseOrderLayer";

const ApprovedPurchaseOrder = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <ApprovedPurchaseOrderLayer />
      </MasterLayout>
    </>
  );
};

export default ApprovedPurchaseOrder